import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { AngularFirestore } from '@angular/fire/firestore';
import { AuthorizationService } from '../authorization/authorization.service';
import {
  LoginAccountServerResponseInterface,
  OrganizationInterface,
  OrganizationInterfaceWithId, OrgStaffUserInterface,
  OrgStaffUserInterfaceWithId
} from '@sk/sk-interfaces';

@Injectable({
  providedIn: 'root'
})
export class PwaUserService {

  constructor(private af: AngularFirestore,
              private authService: AuthorizationService) {
  }


  getCurrentUser(): Observable<OrgStaffUserInterfaceWithId> {
    return this.authService.getCurrentAuth()
      .pipe(
        switchMap((res: LoginAccountServerResponseInterface) => {
          if (!res) {
            throwError('No auth');
          }
          return this.af.collection('organizations').doc(res.organizationId)
            .collection('users').doc(res.organizationUid).snapshotChanges()
            .pipe(
              map(a => {
                const data = a.payload.data() as OrgStaffUserInterface;
                const id = a.payload.id;
                const exists = a.payload.exists;
                return { id, exists, ...data } as OrgStaffUserInterfaceWithId;
              })
            )
        }),
        map(user => {
          return user as OrgStaffUserInterfaceWithId;
        })
      );
    ;
  }


  getOrganization(): Observable<OrganizationInterfaceWithId> {
    return this.authService.getCurrentAuth()
      .pipe(
        switchMap((res: LoginAccountServerResponseInterface) => {
          if (!res) {
            throwError('No auth');
          }
          return this.af.collection('organizations').doc(res.organizationId)
            .snapshotChanges();
        }),
        map(a => {
          const data = a.payload.data() as OrganizationInterface;
          const id = a.payload.id;
          const exists = a.payload.exists;
          return { id, exists, ...data } as OrganizationInterfaceWithId;
        })
      );
  }




}
